import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { Message } from 'semantic-ui-react';
import { setNewPasswordAfterForgetting } from 'api-operations/auth';
import ErrorModal from 'errors/components/ErrorModal';
import { hasErrorCode } from 'logger/error-guards';
import AuthFormLayout from './AuthFormLayout';
import ValidatedInput from './ValidatedInput';
import { usePassword, usePasswordConfirmation } from './useFieldHooks';
import { StyledForm, StyledButton, ButtonWrapper, FormTitle, FormDescription, AccountLinkText, BackButton, } from './AuthFormStyles';
const PasswordReset = () => {
    const password = usePassword();
    const passwordConfirmation = usePasswordConfirmation(password.value);
    const [loading, setLoading] = useState(false);
    const [badToken, setBadToken] = useState(false);
    const [incorrectNewPassword, setIncorrectNewPassword] = useState(false);
    const [passwordChanged, setPasswordChanged] = useState(false);
    const [errorWindowMessage, setErrorWindowMessage] = useState(null);
    const { t } = useTranslation('common');
    const history = useHistory();
    const params = new URLSearchParams(window.location.search);
    const redirectURL = params.get('redirectURL');
    console.log(redirectURL);
    const handleSubmit = async () => {
        setLoading(true);
        setBadToken(false);
        setIncorrectNewPassword(false);
        const token = params.get('token');
        if (password.value !== '' && passwordConfirmation.value !== '') {
            try {
                await setNewPasswordAfterForgetting(token, password.value);
                setPasswordChanged(true);
                setTimeout(function () {
                    redirectURL !== null ? window.location.replace(redirectURL) : history.push('/');
                }, 3000);
            }
            catch (error) {
                if (hasErrorCode(401, error)) {
                    setBadToken(true);
                }
                else if (hasErrorCode(400, error)) {
                    setIncorrectNewPassword(true);
                }
                else {
                    setErrorWindowMessage(error);
                }
            }
            setLoading(false);
        }
    };
    if (errorWindowMessage !== null) {
        return React.createElement(ErrorModal, { ...errorWindowMessage, onClose: () => window.location.reload() });
    }
    return (React.createElement(AuthFormLayout, { showBottomSection: true, bottomSection: React.createElement(AccountLinkText, null,
            React.createElement(BackButton, { onClick: () => redirectURL !== null ? window.location.replace(redirectURL) : history.push('/') },
                React.createElement("svg", { viewBox: "0 0 24 24", fill: "currentColor" },
                    React.createElement("path", { d: "M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z" })),
                t('signin.signin'))) },
        React.createElement(StyledForm, { autoComplete: "off", onSubmit: handleSubmit },
            React.createElement(FormTitle, null, t('signin.resetPassword')),
            React.createElement(FormDescription, null, t('signin.enterNewPassword')),
            React.createElement(ValidatedInput, { type: "password", id: "password", value: password.value, onChange: password.handleChange, placeholder: t('settings.newPassword'), errorMessage: password.errorMessage, touched: password.touched, autoFocus: true }),
            React.createElement(ValidatedInput, { type: "password", id: "passwordConfirmation", value: passwordConfirmation.value, onChange: passwordConfirmation.handleChange, placeholder: t('settings.passwordConfirmation'), errorMessage: passwordConfirmation.errorMessage, touched: passwordConfirmation.touched }),
            badToken && React.createElement(Message, { negative: true }, t('signin.badToken')),
            incorrectNewPassword && React.createElement(Message, { negative: true }, t('signin.incorrectPassword')),
            passwordChanged && React.createElement(Message, { positive: true }, t('signin.passwordChanged')),
            React.createElement(ButtonWrapper, null,
                React.createElement(StyledButton, { loading: loading, disabled: loading || !password.isValid || !passwordConfirmation.isValid, primary: true, content: t('signin.setPassword'), type: "submit" })))));
};
export default PasswordReset;
